import { ColDef } from 'ag-grid-community';
import { t } from 'i18next';

import { AvatarNameCell } from 'core/elements';
import { NumberHelper } from 'core/helpers';
import { formatDate } from 'core/utils';
import { PricingHelper } from 'pricing/helpers';

import { ActionsCell } from './cells';

export const columnDef = () => {
  return [
    {
      colId: 'actions',
      width: 80,
      maxWidth: 80,
      sortable: false,
      resizable: false,
      enableRowGroup: false,
      suppressHeaderMenuButton: true,
      suppressColumnsToolPanel: true,
      pinned: 'left',
      lockPinned: true,
      cellRenderer: ActionsCell,
      cellClass: 'noDecorationCell',
    },
    {
      colId: 'description',
      headerName: t('headerTask'),
      field: 'description',
      filter: 'agTextColumnFilter',
    },
    {
      colId: 'note',
      headerName: t('headerNote'),
      field: 'note',
      filter: 'agTextColumnFilter',
      editable: true,
      cellEditor: 'agLargeTextCellEditor',
      cellEditorPopup: true,
      valueGetter: ({ data }) => (data && data.note) || '',
    },
    {
      colId: 'userName',
      headerName: t('headerUser'),
      field: 'userName',
      filter: 'agTextColumnFilter',
      cellRenderer: AvatarNameCell,
    },
    {
      colId: 'activityDate',
      headerName: t('headerActivityDate'),
      field: 'activityDate',
      filter: 'agDateColumnFilter',
      valueFormatter: ({ value }) => value && formatDate(value),
    },
    {
      colId: 'duration',
      headerName: t('headerDurationHours'),
      field: 'duration',
      filter: 'agNumberColumnFilter',
      editable: true,
      aggFunc: 'sum',
      cellEditor: 'agNumberCellEditor',
      cellEditorParams: {
        min: 0,
        max: 24,
        step: 0.25,
        precision: 2,
      },
      valueGetter: ({ data }) => (data ? Number(data.duration) : 0),
      valueFormatter: ({ value }) => value && NumberHelper.format({ amount: value }),
    },
    {
      colId: 'cost',
      headerName: t('headerCostPerHour'),
      field: 'cost',
      filter: 'agNumberColumnFilter',
      aggFunc: 'sum',
      valueFormatter: ({ value }) =>
        value && `${PricingHelper.formatPricing({ amount: value })}/hr`,
    },
    {
      colId: 'totalCost',
      headerName: t('headerCost'),
      filter: 'agNumberColumnFilter',
      aggFunc: 'sum',
      valueGetter: ({ data }) =>
        data && PricingHelper.formatPricing({ amount: data.cost * data.duration }),
    },
    {
      colId: 'price',
      headerName: t('headerPricePerHour'),
      field: 'price',
      filter: 'agNumberColumnFilter',
      aggFunc: 'sum',
      valueFormatter: ({ value }) =>
        value && `${PricingHelper.formatPricing({ amount: value })}/hr`,
    },
    {
      colId: 'totalPrice',
      headerName: t('headerPrice'),
      filter: 'agNumberColumnFilter',
      aggFunc: 'sum',
      valueGetter: ({ data }) =>
        data && PricingHelper.formatPricing({ amount: data.price * data.duration }),
    },
  ] as ColDef[];
};
